let config = [
  {
    name: '专场活动',
    type: 'module-name'
  },
  {
    key: 'property_data',
    name: '属性',
    type: 'custom',
    content: [
      {
        key: 'type',
        name: '样式',
        type: 'radio-box-img',
        width: 84,
        'radio-list': [
          {
            url:
              'https://img.mockuai.com/tms/2018/1/10/upload_c9b8a668b7812c4277a638986eab1e93.png',
            value: 1,
            text: '单列'
          },
          {
            url:
              'https://img.mockuai.com/tms/2018/1/10/upload_0e22c83e15505e62389bcc0d9868a458.png',
            value: 2,
            text: '三列'
          }
        ]
      },
      {
        key: 'list',
        name: '数据',
        type: 'upload-data',
        link_down: 'https://cdn.mockuai.com/tms/template-special-01.xlsx',
        format: (list)=>{
          const map = {
            '推荐词': 'keyword',
            '佣金率': 'commission',
            '活动价': 'price',
            '标题': 'title',
            '图片': 'img_url',
            '商品ID': 'id'
          };
          const data = list.map(item=>{
            const obj = {};
            Object.keys(item).forEach(key=>{
              const mapKey = map[key];
              obj[mapKey] = item[key];
            });
            return obj;
          });
          return data;
        }
      },
      {
        key: 'item_bg',
        name: '背景色',
        type: 'gradient-color'
      },
    ]
  }
];
export default config;
